/**
 * Whether this client serves the web address: built with
 * `VITE_PLATFORM_API_PATH`, it reaches the platform API on its own origin, and
 * the web router in front of it decides by session which workspace answers.
 */
export function onWebAddress(): boolean {
  return Boolean(import.meta.env.VITE_PLATFORM_API_PATH?.trim());
}

/**
 * Opens `path` once the account in the browser changed: signed in, registered,
 * joined a team, or signed out. On the web address a fresh document loads it,
 * so the router serves the new session's workspace and the gate reconciles the
 * stored account data; elsewhere the in-app router navigates.
 */
export function openAfterAccountChange(
  path: "/" | "/sign-in",
  navigate: (path: "/" | "/sign-in") => void,
): void {
  if (onWebAddress()) window.location.replace(path);
  else navigate(path);
}
